import { render, staticRenderFns } from "./MockCenter.vue?vue&type=template&id=789d8213&scoped=true&"
import script from "./MockCenter.vue?vue&type=script&lang=js&"
export * from "./MockCenter.vue?vue&type=script&lang=js&"
import style0 from "./MockCenter.vue?vue&type=style&index=0&id=789d8213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d8213",
  null
  
)

export default component.exports